import { useConfig as hook } from '@eika-infrastruktur/config-provider';
import { nbTranslations, nnTranslations } from './translations';
const defaultTexts = {
    header: 'Hei på deg',
    buttonText: 'sopa',
    ekstraText: 'extra',
};
export const defaultConfig = {
    links: {
        boliglaanurl: {
            url: 'https://www.eika.no',
        },
    },
    siteLang: 'nb',
    translations: {
        nb: nbTranslations,
        nn: nnTranslations,
    },
    texts: defaultTexts,
};
function createHook() {
    return () => hook();
}
export const useConfig = createHook();
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGVmYXVsdC1jb25maWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZGVmYXVsdC1jb25maWcudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFNBQVMsSUFBSSxJQUFJLEVBQWMsTUFBTSxxQ0FBcUMsQ0FBQztBQUVwRixPQUFPLEVBQUUsY0FBYyxFQUFFLGNBQWMsRUFBMEIsTUFBTSxnQkFBZ0IsQ0FBQztBQUV4RixNQUFNLFlBQVksR0FBRztJQUNqQixNQUFNLEVBQUUsWUFBWTtJQUNwQixVQUFVLEVBQUUsTUFBTTtJQUNsQixVQUFVLEVBQUUsT0FBTztDQUN0QixDQUFDO0FBb0JGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBVztJQUNqQyxLQUFLLEVBQUU7UUFDSCxZQUFZLEVBQUU7WUFDVixHQUFHLEVBQUUscUJBQXFCO1NBQzdCO0tBQ0o7SUFDRCxRQUFRLEVBQUUsSUFBYTtJQUN2QixZQUFZLEVBQUU7UUFDVixFQUFFLEVBQUUsY0FBYztRQUNsQixFQUFFLEVBQUUsY0FBYztLQUNyQjtJQUNELEtBQUssRUFBRSxZQUFZO0NBQ3RCLENBQUM7QUFFRixTQUFTLFVBQVU7SUFDZixPQUFPLEdBQUcsRUFBRSxDQUFDLElBQUksRUFBSyxDQUFDO0FBQzNCLENBQUM7QUFFRCxNQUFNLENBQUMsTUFBTSxTQUFTLEdBQUcsVUFBVSxFQUF3QixDQUFDIn0=